<template>
    <section class="app-spa">
        <section class="app-spa__box">
            <section class="app-spa__box__logo">
                <img :src="$appConfig.logo.path" :alt="$appConfig.logo.alt" />
            </section>
            <section class="app-spa__box__form">
                <h1 class="app-spa__box__form__header">{{$t('com.file.user-reset-password.reset-password')}}</h1>
                <section class="app-spa__box__form__wrapper" v-if="isSuccess && showResponse && !passworchChangedSuccess">

                    <section class="app-spa__box__form__fallback-error" v-if="showPasswordStatus && passworchChangedFailed">
                        <img src="@/assets/icons/components/error-alert.svg" class="app-spa__box__form__fallback-error__icon" :alt="$t('com.file.user-reset-password.error-icon')" />
                        <span class="app-spa__box__form__fallback-error__text">
                            {{$t('com.file.user-reset-password.check-data')}}
                        </span>
                    </section>
                    <section class="app-spa__box__form__row">
                        <label for="user-email" class="app-spa__box__form__label">{{$t('com.file.login.password')}}</label>
                        <input type="password"
                               name="user-email"
                               id="user-email"
                               class="app-spa__box__form__input"
                               v-model="ressetPasswordRequest.password"
                               :placeholder="$t('com.file.user-reset-password.input-new-password')"
                               autocomplete="off" />
                    </section>
                    <section class="app-spa__box__form__row">
                        <label for="user-email" class="app-spa__box__form__label">{{$t('com.file.user-reset-password.repeat-password')}}</label>
                        <input type="password"
                               name="user-email"
                               id="user-email"
                               class="app-spa__box__form__input"
                               v-model="ressetPasswordRequest.passwordConfirm"
                               :placeholder="$t('com.file.user-reset-password.input-new-password')"
                               autocomplete="off" />
                    </section>
                    <ReCaptchaComponent v-model="ressetPasswordRequest.reCaptchToken" />
                    <button type="button"
                            class="app-spa__box__form__btn"
                            @click="resetPassword">
                        {{$t('com.file.user-reset-password.change-password')}}
                    </button>
                </section>


                <section class="app-spa__box__form__fallback-success" v-else-if="isSuccess && showResponse && passworchChangedSuccess && showPasswordStatus">
                    <img src="@/assets/icons/components/success-alert.svg" class="app-spa__box__form__fallback-success__icon" :alt="$t('com.file.user-reset-password.error-icon')" />
                    <span class="app-spa__box__form__fallback-error__text">
                        {{$t('com.file.user-reset-password.password-changed')}} <br />
                        {{$t('com.file.user-reset-password.can')}} <router-link :to="{name: 'Login'}" style="cursor: pointer; text-decoration:underline; font-weight:bold;">{{$t('com.file.user-reset-password.log-in')}}</router-link> {{$t('com.file.user-reset-password.on-your-account')}}
                    </span>
                </section>


                <section class="app-spa__box__form__fallback-error" v-else-if="isError && showResponse">
                    <img src="@/assets/icons/components/error-alert.svg" class="app-spa__box__form__fallback-error__icon" :alt="$t('com.file.user-reset-password.error-icon')" />
                    <span class="app-spa__box__form__fallback-error__text">
                        {{ message }}
                    </span>
                </section>

                <section class="app-spa__box__form__fallback-checking" v-else>
                    <span class="app-spa__box__form__fallback-error__text">
                        {{$t('com.file.user-reset-password.link-checked')}}
                    </span>
                </section>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    import ReCaptchaComponent from "../../../BasicControls/ReCaptchaComponent.vue";
    import UserService from "../../../../services/user.service";
    export default {
        name: "UserResetPassword",
        components: {
            ReCaptchaComponent
        },
        computed: {
            passwordToken() {
                return this.$route.params.token;
            },
        },
        data() {
            return {
                showResponse: false,
                isError: false,
                isSuccess: false,
                message: "",

                passworchChangedSuccess: false,
                passworchChangedFailed: false,

                showPasswordStatus: false,

                ressetPasswordRequest: {
                    password: "",
                    passwordConfirm: "",
                    token: "",
                    reCaptchToken: ""
                }
            }
        },
        async mounted() {
            await this.validateToken();
        },
        methods: {
            async validateToken() {
                try {
                    this.showResponse = false;
                    this.isError = false;
                    this.isSuccess = false;
                    this.$store.commit("showLoader");
                    let response = await UserService.validateResetPasswordToken(this.passwordToken);
                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }
                    this.isSuccess = true;
                }
                catch (e) {
                    this.isError = true;
                    this.message = e.response.data;
                }
                finally {
                    this.showResponse = true;
                    this.$store.commit("hideLoader");
                }
            },

            async resetPassword() {
                try {
                    this.passworchChangedSuccess = false;
                    this.passworchChangedFailed = false;
                    this.showPasswordStatus = false;
                    this.$store.commit("showLoader");
                    this.ressetPasswordRequest.token = this.passwordToken;

                    let response = await UserService.resetUserPassword(this.ressetPasswordRequest)

                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }

                    this.passworchChangedSuccess = true;
                }
                catch (e) {
                    this.passworchChangedFailed = true;
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'sms' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.showPasswordStatus = true;
                    this.$store.commit("hideLoader");
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @use  "~@/assets/scss/esesja-app-spa.scss";
    .app-spa__box__form__wrapper {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
    }
</style>